module.exports = __webpack_public_path__ + "img/helpbutton.52772caf.png";